module.exports = __webpack_public_path__ + "static/media/icon_default_image_enabled.5648a715.png";